import { render, staticRenderFns } from "./QuizTeamResultTextV2.vue?vue&type=template&id=2c38afa8&scoped=true&"
import script from "./QuizTeamResultTextV2.vue?vue&type=script&lang=js&"
export * from "./QuizTeamResultTextV2.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeamResultTextV2.vue?vue&type=style&index=0&id=2c38afa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c38afa8",
  null
  
)

export default component.exports